// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"316":"component---src-pages-datenschutz-tsx","524":"component---src-pages-impressum-tsx","678":"component---src-pages-index-js"}[chunkId] + "-" + {"316":"5c798e0ab1e2f53736c6","524":"fa7d76851f97a5851848","678":"1c6dafc67cd5b78d97c2"}[chunkId] + ".js";
};